/**
 * Native replacements for lodash/fp `camelCase`, `snakeCase`, and `startCase`.
 *
 * All three share a `words` splitter that mirrors lodash's ASCII word-splitting:
 * it breaks on separators (space, `_`, `-`, punctuation), on camelCase humps
 * (lower→upper transitions), on acronym boundaries (`FOOBar` → `FOO`, `Bar`),
 * and on digit runs.
 */

const WORDS_RE = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]+|[0-9]+/g;

function words(str: string | null | undefined): string[] {
    return str == null ? [] : (str.match(WORDS_RE) ?? []);
}

const upperFirst = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

export function camelCase(str: string | null | undefined): string {
    return words(str).reduce((result, word, index) => {
        const lower = word.toLowerCase();
        return result + (index ? upperFirst(lower) : lower);
    }, '');
}

export function snakeCase(str: string | null | undefined): string {
    return words(str)
        .map(word => word.toLowerCase())
        .join('_');
}

export function startCase(str: string | null | undefined): string {
    return words(str).map(upperFirst).join(' ');
}
